/* Detailing1 Paket D 2026-09: natives Teilen (Web Share API) mit Fallback "Link kopieren" + Hilfe-Link, der Intercom öffnet. */
(function () {
  if (!customElements.get('d1-share')) {
    class D1Share extends HTMLElement {
      connectedCallback() {
        this.btn = this.querySelector('.js-d1-share');
        this.status = this.querySelector('.js-d1-share-status');
        this.fallback = this.querySelector('.js-d1-share-fallback');
        if (this.btn) this.btn.addEventListener('click', this.share.bind(this));
      }

      async share(evt) {
        evt.preventDefault();
        const data = { title: this.dataset.title, url: this.dataset.url };
        if (typeof navigator.share === 'function' && (!navigator.canShare || navigator.canShare(data))) {
          try {
            await navigator.share(data);
            return;
          } catch (error) {
            if (error && error.name === 'AbortError') return;
          }
        }
        try {
          await navigator.clipboard.writeText(data.url);
          this.flash(this.dataset.copied);
        } catch (error) {
          if (this.fallback) this.fallback.hidden = !this.fallback.hidden;
        }
      }

      flash(text) {
        if (!this.status) return;
        this.status.textContent = text;
        clearTimeout(this.timer);
        this.timer = setTimeout(() => { this.status.textContent = ''; }, 2500);
      }
    }
    customElements.define('d1-share', D1Share);
  }

  // Hilfe-Link: Intercom-Messenger öffnen, wenn er geladen ist – sonst dem Link folgen.
  document.addEventListener('click', (evt) => {
    const link = evt.target.closest('.js-d1-help');
    if (!link) return;
    const ic = window.Intercom;
    if (typeof ic === 'function' && ic.booted) {
      evt.preventDefault();
      ic('show');
    }
  });
})();
